import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'routeReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as routeReportActions };
export { reducer as routeReportReducer };
